import { z } from 'zod';

export const costCalculatorPostRequestSchema = z.object({
  buy_to_let: z.string(),
  deposit: z.string(),
  property_value: z.string(),
  term: z.string(),
});
